import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WaitingInLinePass } from '../models/WaitInLine';
import { HttpService } from './http-service';
import { filter } from 'rxjs/operators';
import { StartWaitingInLinePassResponse } from './hall-passes.service';
import { LiveDataService } from '../live-data/live-data.service';

export const sortWil = (pass1: WaitingInLinePass, pass2: WaitingInLinePass): number => {
	const date = new Date();
	const timeDifference = (pass1?.start_attempt_end_time || date).getTime() - (pass2?.start_attempt_end_time || date).getTime();
	if (timeDifference !== 0) {
		// first sorts by start_attempt_end_time
		return timeDifference;
	}

	// if the times are equal or both times are null, sort by line position
	return pass1.line_position - pass2.line_position;
};

/**
 * This service contains all business logic responsible for interacting with the WaitingInLine API and
 * handling its data between components.
 */
@Injectable({
	providedIn: 'root',
})
export class WaitInLineService {
	constructor(private http: HttpService, private liveData: LiveDataService) {}

	startWilPassNow(id: number): Observable<StartWaitingInLinePassResponse> {
		const waiting_in_line_pass_id = id;
		return this.http.post<StartWaitingInLinePassResponse>('v2/hall_passes/start_waiting_in_line_pass', { waiting_in_line_pass_id }, undefined, false);
	}

	deleteWilPass(id: number): Observable<never> {
		return this.http.post('v2/waiting_in_line_pass/delete', { waiting_in_line_pass_id: id }, undefined, false);
	}

	listenForWilUpdate(id: string | number) {
		return this.liveData.watchUpdatedWaitingInLine().pipe(filter((event) => event.data.id == id));
	}

	listenForWilDeletion(id: string | number) {
		return this.liveData.watchDeletedWaitingInLine().pipe(filter((event) => event.data.id == id));
	}
}
